import { render, staticRenderFns } from "./LogsTableOCPI.vue?vue&type=template&id=72f3f808&scoped=true&"
import script from "./LogsTableOCPI.vue?vue&type=script&lang=js&"
export * from "./LogsTableOCPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3f808",
  null
  
)

export default component.exports